import { useReducer } from "react";
import AuthContext from "./AuthContext";
import AuthReducer from "./AuthReducer";
import { useNavigate } from "react-router-dom";
import useTranslator from "../../hooks/useTranslator";

import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  USER_LOADED,
  CARD_DATA,
  LOGIN_SUCCESS,
  LOGOUT,
  TOGGLE_LOGIN,
  TOGGLE_LOADING,
  TOGGLE_BANK_LOADING,
  TOGGLE_ALGOAN_LOADING,
  SET_USER_TYPE,
  SETOTP_PAGE,
  USER_VERIFIED,
  NOTIFICATION_LOADED,
  LOGGED_IN_TRUE,
  USER_UNVERIFIED,
  TOGGLE_NEW_WORKSPACE_MODAL,
  ERROR_DATA_LOADING,
} from "../types";
import "react-toastify/dist/ReactToastify.css";
import { haveValue, toast } from "../../helper/common";
import constants from "../../Utils/constants";
import axiosInstance from "../../services/authWrapper";

const AuthState = (props) => {
  const navigate = useNavigate();
  const { _t } = useTranslator();

  const initialState = {
    loading: false,
    alertMsg: "",
    msg: "",
    user: null,
    isLoggedIn: false,
    errorMessage: "",
    userType: "tenant",
    otppage: 0,
    verified: false,
    notifications: [],
    bankLoading: false,
    algoanLoading: false,
    workspaceList: [],
    openNewWorkspaceModal: false,
    errorDataLoading: false,
  };

  let token = localStorage.getItem("token");
  let is_verified = localStorage.getItem("is_verified");
  if (token && is_verified && is_verified == true) {
    initialState.isLoggedIn = true;
    initialState.verified = true;
  }

  const [state, dispatch] = useReducer(AuthReducer, initialState);

  // login
  const login = (user) => {
    setLoading(true);
    axiosInstance
      .post(`${process.env.REACT_APP_SERVER_URL}/users/login`, user, {
        headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
      })
      .then((res) => {
        let serverResponse = res;
        let usertype = localStorage.getItem("usertype");
        if (serverResponse.data.token) {
          localStorage.setItem("token", serverResponse.data.token);
          localStorage.setItem("is_verified", true);

          dispatch({
            type: USER_VERIFIED,
          });
          dispatch({
            type: LOGIN_SUCCESS,
          });
          loadUser(usertype);
        } else {
          alert(_t("loginFailed"));
        }
      })
      .catch((e) => {
        let emsg = e;
        console.log(emsg.response.data);
        alert(emsg.response.data.message);
      });
  };
  // register
  const register = async (userData) => {
    await axiosInstance
      .post(`${process.env.REACT_APP_SERVER_URL}/users/signup`, userData, {
        headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
      })
      .then((res) => {
        let serverResponse = res;
        if (serverResponse.data.token) {
          localStorage.setItem("token", serverResponse.data.token);
          localStorage.setItem("saveduserid", serverResponse.data.user._id);
          let usertype = localStorage.getItem("usertype");

          if (localStorage.getItem("i18nextLng") == "es")
            sendOTPES(serverResponse.data.user._id, usertype);
          else sendOTP(serverResponse.data.user._id, usertype);

          dispatch({
            type: REGISTER_SUCCESS,
            payload: serverResponse.data,
          });
          loadUser(usertype);
        } else {
          localStorage.removeItem("token");
          dispatch({
            type: REGISTER_FAIL,
            payload: serverResponse.data,
          });
          toast.error(serverResponse.data);
        }
      })
      .catch((err) => {
        localStorage.removeItem("token");
        let emsg = err;
        console.log(emsg.response.data);
        toast.error(emsg.response.data.errormsg);
        dispatch({
          type: REGISTER_FAIL,
          payload: emsg.response.data.errormsg,
        });
      });
  };
  const forgotPassword = async (userData) => {
    const res = await axiosInstance
      .post(
        `${process.env.REACT_APP_SERVER_URL}/users/forgotPassword`,
        userData,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      )
      .then(async (res) => {
        if (res.data.found) {
          let usertype = localStorage.getItem("usertype");

          localStorage.setItem("token", res.data.token);
          localStorage.setItem("saveduserid", res.data.user._id);
          localStorage.setItem("external_customer_id", res.data.user._id);
          dispatch({
            type: REGISTER_SUCCESS,
            payload: res.data.user,
          });
          dispatch({
            type: SETOTP_PAGE,
            payload: 0,
          });
          if (localStorage.getItem("i18nextLng") == "es")
            await sendOTPES(res.data.user._id, usertype);
          else await sendOTP(res.data.user._id, usertype);
          navigate("/enter-otp");
        }
      })
      .catch((err) => {
        let emsg = err;
        console.log(emsg.response.data);
        toast.error(emsg.response.data.errormsg);
      });
    if (haveValue(res)) {
      return res;
    }
  };
  const changePassword = async (passData, userid) => {
    const res = await axiosInstance
      .post(
        `${process.env.REACT_APP_SERVER_URL}/users/newpassword/${userid}`,
        passData,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      )
      .then(async (res) => {
        return true;
      })
      .catch((err) => {
        let emsg = err;
        console.log(emsg.response.data);
        toast.error(emsg.response.data.errormsg);
        return false;
      });
    return res;
  };

  const checkIeDetails = (userDetails) => {
    var check = false;
    return check;
  };

  const loadUser = async (usertype, windowLocation = "") => {
    setLoading(true);
    setUserType(usertype);
    // if (usertype == 'tenant') {
    const userid = localStorage.getItem("saveduserid");
    if (!haveValue(windowLocation) || windowLocation != "stepform")
      loadMyNotifications(userid, usertype);
    // }
    await axiosInstance
      .get(
        `${process.env.REACT_APP_SERVER_URL}/users/protect?type=${usertype}`,
        {
          headers: {
            // "x-access-token": localStorage.getItem("token"),
            "Accept-Language": localStorage.getItem("i18nextLng"),
          },
        }
      )
      .then((res) => {
        let serverResponse = res.data;
        localStorage.setItem("saveduserid", serverResponse._id);
        localStorage.setItem("external_customer_id", serverResponse._id);
        if (haveValue(serverResponse?.ie_details_id)) {
          res.data.ie_verified = checkIeDetails(serverResponse);
        }

        dispatch({
          type: USER_LOADED,
          payload: res.data,
        });
      })
      .catch((err) => {
        setLoading(false);
        let serverResponse = err;
        localStorage.removeItem("is_verified");
        // logout();
        // toast.error(serverResponse?.response?.data?.msg);
      });
  };
  const loadUserTenant = async (usertype) => {
    setUserType(usertype);

    // loadMyNotifications(userid, usertype)
    await axiosInstance
      .get(
        `${process.env.REACT_APP_SERVER_URL}/users/protect?type=${usertype}`,
        {
          headers: {
            // "x-accesss-token": localStorage.getItem("token"),
            "Accept-Language": localStorage.getItem("i18nextLng"),
          },
        }
      )
      .then((res) => {
        let serverResponse = res.data;
        localStorage.setItem("saveduserid", serverResponse._id);
        localStorage.setItem("external_customer_id", serverResponse._id);

        if (haveValue(serverResponse?.ie_details_id)) {
          res.data.ie_verified = checkIeDetails(serverResponse);
        }
        dispatch({
          type: USER_LOADED,
          payload: res.data,
        });
        const user_data = res.data;
        if (
          +user_data?.myScore == 100 &&
          user_data?.user_type == constants.MACC &&
          !user_data?.macc_landlord_mail_sent
        ) {
          axiosInstance.post(
            `${process.env.REACT_APP_SERVER_URL}/tenants/send-macc-email/${serverResponse._id}/${process.env.REACT_APP_MACC_LANDLORED_ID}`
          );
        }
      })
      .catch((err) => {
        let serverResponse = err;
        console.log(serverResponse, "Server ERROR HERE!");
        // toast.error(serverResponse.response.data.msg);
      });
  };

  const getUserDetails = async (usertype, userId) => {
    const res_data = await axiosInstance
      .get(
        `${process.env.REACT_APP_SERVER_URL}/users/get-single/${userId}?type=${usertype}`,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        console.log(err);
        toast.error(err?.response?.data?.msg ?? err.message);
      });
    return res_data;
  };

  const getPendingGuaantees = async (data) => {
    if (!localStorage.getItem("saveduserid")) {
      return;
    }
    const queryParams = new URLSearchParams(data).toString();

    const res_data = await axiosInstance
      .get(
        `${process.env.REACT_APP_SERVER_URL}/tenants/getPendingGuranteesRequests?${queryParams}`,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        console.log(err);
      });

    if ((res_data?.success_res ?? []).length === 0) {
      localStorage.removeItem("guarantorFor");
    }
    return res_data;
  };

  const getPendingFlatemates = async () => {
    if (!localStorage.getItem("saveduserid")) {
      return;
    }
    const res_data = await axiosInstance
      .get(
        `${process.env.REACT_APP_SERVER_URL}/tenants/getPendingFlatematesRequests`,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        console.log(err);
      });
    return res_data;
  };

  const getGuarantorDetails = async (usertype, userId) => {
    return await axiosInstance
      .get(
        `${process.env.REACT_APP_SERVER_URL}/users/get-gurantor/${userId}?type=${usertype}`,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        console.log(err);
        // toast.error(
        //   _t(
        //     "guarantorEmailMismatch",
        //     "If tenant entered guarantor email and logged in user email does not match"
        //   )
        // );
        throw new Error(err?.response?.data?.msg ?? err.message);
      });
  };

  const setUserType = (value) => {
    localStorage.removeItem("usertype");
    localStorage.setItem("usertype", value);
    dispatch({
      type: SET_USER_TYPE,
      payload: value,
    });
  };

  const setLoggedInUser = () => {
    dispatch({
      type: LOGGED_IN_TRUE,
    });
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("saveduserid");
    localStorage.removeItem("is_verified");
    localStorage.removeItem("loggedin_by");

    dispatch({
      type: USER_UNVERIFIED,
    });
    dispatch({
      type: LOGOUT,
    });
    toast.success(_t("loggedOutSuccessfully"));
  };
  const toggleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("saveduserid");
    localStorage.removeItem("is_verified");
    localStorage.removeItem("loggedin_by");

    dispatch({
      type: USER_UNVERIFIED,
    });
    dispatch({
      type: LOGOUT,
    });
  };
  const resetPassword = async (value, email) => {
    if (!email) {
      toast.error(_t("pleaseEnterYourEmailId"));
      return null;
    }

    try {
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/users/changepassword/${email}`,
        value,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );

      toast.success(res?.data?.msg);
      return res;
    } catch (err) {
      console.log(err);
      toast.error(err?.response?.data?.msg);
      return null;
    }
  };

  const changeImage = async (value, userid) => {
    await axiosInstance
      .patch(
        `${process.env.REACT_APP_SERVER_URL}/users/upload-image/${userid}`,
        value,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      )
      .then((res) => {
        if (res.data.msg == "Image updated") {
          toast.success(res.data.msg);
        } else {
          toast.error(_t("imageUploadFailed"));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const toggleLogin = (value) => {
    dispatch({
      type: TOGGLE_LOGIN,
      payload: value,
    });
  };
  const setLoading = (value) => {
    dispatch({
      type: TOGGLE_LOADING,
      payload: value,
    });
  };
  const setBankLoading = (value) => {
    dispatch({
      type: TOGGLE_BANK_LOADING,
      payload: value,
    });
  };
  const setAlgoanLoading = (value) => {
    dispatch({
      type: TOGGLE_ALGOAN_LOADING,
      payload: value,
    });
  };
  const setotpPage = (value) => {
    dispatch({
      type: SETOTP_PAGE,
      payload: value,
    });
  };
  const sendOTP = async (email, usertype, customEmail) => {
    let url = `${process.env.REACT_APP_SERVER_URL}/users/otp-verify/${email}?type=${usertype}`;
    if (customEmail) {
      url += `&customEmail=${customEmail}`;
    }
    await axiosInstance
      .get(url, {
        headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
      })
      .then((res) => {
      })
      .catch((err) => {
        let serverResponse = err;
        console.log(serverResponse);
        toast.error(
          serverResponse.response.data.msg ||
          serverResponse.response.data.errormsg ||
          _t("error")
        );
      });
  };
  const sendOTPES = async (email, usertype, customEmail) => {
    let url = `${process.env.REACT_APP_SERVER_URL}/users/otp-verify/es/${email}?type=${usertype}`;
    if (customEmail) {
      url += `&customEmail=${customEmail}`;
    }
    await axiosInstance
      .get(url, {
        headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
      })
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        let serverResponse = err;
        console.log(serverResponse);
        toast.error(serverResponse.response.data.msg);
      });
  };
  const verifyOTP = async (userid, value) => {
    await axiosInstance
      .put(
        `${process.env.REACT_APP_SERVER_URL}/users/otp-verify/${userid}`,
        value,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      )
      .then((res) => {
        let serverResponse = res;
        let usertype = localStorage.getItem("usertype");
        localStorage.setItem("is_verified", true);
        if (serverResponse.data.status == "verified") {
          loadUser(usertype);
          dispatch({
            type: USER_VERIFIED,
          });
        }
      })
      .catch((err) => {
        let serverResponse = err;
        console.log(serverResponse);
        toast.error(serverResponse.response.data.msg);
      });
  };
  //notifications
  const loadMyNotifications = async (userid, usertype, lastReadAt = null) => {
    if (haveValue(userid)) {
      await axiosInstance
        .get(
          `${process.env.REACT_APP_SERVER_URL
          }/notifications/${userid}?type=${usertype}${haveValue(lastReadAt) ? "&lastReadAt=true" : ""
          }`,
          { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
        )
        .then((res) => {
          let serverResponse = res.data.notifications;
          serverResponse = serverResponse.reverse();

          dispatch({
            type: NOTIFICATION_LOADED,
            payload: serverResponse,
          });
        })
        .catch((err) => {
          let serverResponse = err;
          console.log(serverResponse);
          toast.error(serverResponse?.response?.data?.msg);
        });
    }
  };

  const updateProfile = async (id, profileData) => {
    setLoading(true);
    try {
      await axiosInstance
        .patch(
          `${process.env.REACT_APP_SERVER_URL}/users/profile/${id}`,
          profileData,
          { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
        )
        .then((res) => {
          setLoading(false);
          toast.success(_t("profileSuccessfullyUpdated"));
          let usertype = localStorage.getItem("usertype");
          loadUser(usertype);
        })
        .catch((err) => {
          setLoading(false);
          let serverResponse = err;
          console.log(serverResponse);
          toast.error(serverResponse.response.data.msg);
        });
    } catch (err) {
      let serverResponse = err;
      console.log("check the server response - ", serverResponse);
      toast.error(serverResponse.response.data.msg);
    }
    setLoading(false);
  };

  const fetchCardDetails = async (cardId) => {
    try {
      await axiosInstance
        .get(
          `${process.env.REACT_APP_SERVER_URL}/users/getCardDetails/${cardId}`,
          { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
        )
        .then((res) => {
          dispatch({
            type: CARD_DATA,
            payload: res.data.cardData,
          });
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
        });
    } catch (err) {
      console.log("Some issue while adding card - ".err);
    }
  };

  const notificationSeen = (notificationid) => {
    axiosInstance
      .patch(
        `${process.env.REACT_APP_SERVER_URL}/notifications/single-notification/${notificationid}`,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      )
      .then((res) => {
        const user_id = localStorage.getItem("saveduserid");
        const user_type = localStorage.getItem("usertype");
        loadMyNotifications(user_id, user_type);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const changeUserLng = () => {
    if (!haveValue(localStorage.getItem("saveduserid"))) {
      return;
    }

    const sendData = {
      current_lng: localStorage.getItem("i18nextLng"),
      id: localStorage.getItem("saveduserid"),
      role: localStorage.getItem("usertype"),
    };

    axiosInstance
      .post(
        `${process.env.REACT_APP_SERVER_URL}/users/changeUserLng`,
        sendData,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      )
      .then((res) => {
        loadUserTenant(localStorage.getItem("usertype"));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updateUserInfo = async (formData = {}) => {
    try {
      const data = {
        formData,
        id: localStorage.getItem("saveduserid"),
        type: localStorage.getItem("usertype"),
      };
      const result = await axiosInstance.patch(
        `${process.env.REACT_APP_SERVER_URL}/users/update/info`,
        data,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return result.data.user;
    } catch (error) {
      toast.error(_t("errorWhileUpdatingInfo"));
    }
  };

  const getUserByEmail = async (data = {}) => {
    try {
      const result = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/users/getUserByEmail`,
        data,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return result.data;
    } catch (error) {
      toast.error(_t("errorWhileUpdatingInfo"));
    }
  };

  const generateLinkedinURL = async (data = {}) => {
    try {
      const result = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/users/generateLinkedinUrl`,
        data,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return result.data;
    } catch (error) {
      toast.error(_t("errorWhileGeneratingLinkedinUrl"));
    }
  };

  const getAllData = async (data, type) => {
    try {
      const result = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/users/getProfileData?type=${type}`,
        data,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return result.data;
    } catch (error) {
      throw error
    }
  };

  const getTenantNameAndDni = async (id) => {
    const res_data = await axiosInstance
      .get(`${process.env.REACT_APP_SERVER_URL}/users/getNameAndDni/${id}`, {
        headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        console.log(err);
        toast.error(err?.response?.data?.msg ?? err.message);
      });
    return res_data;
  };

  const acceptConsent = async (id = null) => {
    const res_data = await axiosInstance
      .post(
        `${process.env.REACT_APP_SERVER_URL}/users/createTenantDocConsent`,
        { id },
        {
          headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
        }
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        console.log(err);
        toast.error(err?.response?.data?.msg ?? err.message);
      });
    return res_data;
  };

  const toggleNewWorkspaceModal = (value) => {
    dispatch({
      type: TOGGLE_NEW_WORKSPACE_MODAL,
      payload: value,
    });
  };

  const setErrorDataLoading = (value) => {
    dispatch({
      type: ERROR_DATA_LOADING,
      payload: value,
    });
  };

  return (
    <AuthContext.Provider
      value={{
        loading: state.loading,
        showAlert: state.showAlert,
        msg: state.msg,
        user: state.user,
        isLoggedIn: state.isLoggedIn,
        errorMessage: state.errorMessage,
        alertMsg: state.alertMsg,
        users: state.users,
        userType: state.userType,
        otppage: state.otppage,
        verified: state.verified,
        notifications: state.notifications,
        cardData: state.cardData,
        bankLoading: state.bankLoading,
        algoanLoading: state.algoanLoading,
        workspaceList: state.workspaceList,
        errorDataLoading: state.errorDataLoading,
        register,
        setotpPage,
        sendOTP,
        sendOTPES,
        verifyOTP,
        loadUser,
        login,
        logout,
        toggleLogout,
        changePassword,
        changeImage,
        setLoggedInUser,
        setUserType,
        fetchCardDetails,
        toggleLogin,
        setLoading,
        loadMyNotifications,
        updateProfile,
        notificationSeen,
        loadUserTenant,
        changeUserLng,
        getUserDetails,
        forgotPassword,
        resetPassword,
        setBankLoading,
        setAlgoanLoading,
        updateUserInfo,
        checkIeDetails,
        getUserByEmail,
        generateLinkedinURL,
        getGuarantorDetails,
        getAllData,
        getTenantNameAndDni,
        acceptConsent,
        getPendingGuaantees,
        getPendingFlatemates,
        openNewWorkspaceModal: state.openNewWorkspaceModal,
        toggleNewWorkspaceModal,
        setErrorDataLoading
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthState;
